import { ViewportType } from 'game-ui-types'

export const configTypeA = {
    [ViewportType.DESKTOP]: {
        playButton: 'absolute left-[1482px] top-[932px] mt-[10px]',
        paginationSection:
            'absolute top-[918px] flex gap-[20px] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center',
        checkBoxSection: 'absolute left-[160px] top-[976px] flex gap-[20px] items-center',
        rightArrowButton: 'absolute left-[1690px] top-[494px]',
        leftArrowButton: 'absolute left-[160px] top-[494px] -scale-x-100',
        featureDescription:
            'absolute left-[420px] top-[736px] w-[1080px] h-[144px] font-bold text-[40px] leading-[48px] text-center px-[60px]',
    },
    [ViewportType.MOBILE_PORTRAIT]: {
        playButton: 'absolute left-[266px] top-[1178px] mt-[10px]',
        paginationSection:
            'absolute top-[972px] flex gap-[20px] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center',
        checkBoxSection: 'absolute left-[258px] top-[1346px] flex gap-[20px] items-center',
        rightArrowButton: 'absolute left-[680px] top-[938px]',
        leftArrowButton: 'absolute left-[60px] top-[938px] -scale-x-100',
        featureDescription:
            'absolute left-[0px] top-[810px] w-[810px] h-[108px] font-bold text-[30px] leading-[36px] text-center px-[60px]',
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        playButton: 'absolute left-[1062px] top-[686px] mt-[10px]',
        paginationSection:
            'absolute top-[681px] flex gap-[20px] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center',
        checkBoxSection: 'absolute left-[100px] top-[730px] flex gap-[20px] items-center',
        rightArrowButton: 'absolute left-[1270px] top-[361px]',
        leftArrowButton: 'absolute left-[100px] top-[361px] -scale-x-100',
        featureDescription:
            'absolute left-[315px] top-[552px] w-[810px] h-[108px] font-bold text-[30px] leading-[36px] text-center px-[60px]',
    },
}
